import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="text-[80px] md:text-[120px] font-black leading-none text-background-300 select-none">404</p>
      <h1 className="mt-2 text-xl md:text-2xl font-black text-foreground-950">这个页面走丢了</h1>
      <p className="mt-2 text-[13px] text-foreground-500 font-mono break-all max-w-full">{location.pathname}</p>
      <p className="mt-3 text-[13px] text-foreground-600 max-w-[420px]">
        可能是链接输入有误，或者页面已经调整。回到首页继续逛逛吧。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="h-10 px-5 inline-flex items-center rounded-md bg-primary-900 hover:bg-primary-800 text-background-50 text-[13px] font-semibold transition-colors whitespace-nowrap cursor-pointer">
          回到首页
        </Link>
        <Link to="/news" className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-[13px] font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
          查看动漫资讯
        </Link>
      </div>
    </div>
  );
}